export class CreateAssetCommand {
    constructor(context, asset) {
        this.context = context;
        this.asset = asset;
    }
}
//# sourceMappingURL=create-asset.command.js.map